
// UPGRADE_ACCOUNT_* / UPGRADE_PROCESS / SET_UPGRADE_PROGRESS were removed on
// 2026-07-29. They drove the PayPal per-seat upgrade, which created a Cloak File
// account via AccountService.create as a side effect of paying. Upgrading is now a
// handoff to Stripe checkout in the KMS console (see pages/UpgradePage.js), so this
// slice no longer runs any async work of its own — only the account-exit path does.
export const EXIT_ACCOUNT_REQUEST = 'EXIT_ACCOUNT_REQUEST'
export const EXIT_ACCOUNT_SUCCESS = 'EXIT_ACCOUNT_SUCCESS'
export const EXIT_ACCOUNT_FAILURE = 'EXIT_ACCOUNT_FAILURE'

export const CREATE_USR_USAGE_REQUEST = 'CREATE_USR_USAGE_REQUEST'

export const exitAccount = () => ({
	type: EXIT_ACCOUNT_REQUEST,
	payload: {}
})

export const createUsrUsage = ( type ) => ({
	type: CREATE_USR_USAGE_REQUEST,
	payload: { type }
})

const initialState = {
	error: null,
	accountName: null
}

export const upgradeReducer = ( state = initialState, { type, payload }) => {
	switch(type){
		case EXIT_ACCOUNT_SUCCESS: {
			return { ...state, accountName: payload, error: '' }
		}
		case EXIT_ACCOUNT_FAILURE: {
			return { ...state, error: payload }
		}
		default:
			return state
	}
}
